module.exports = __webpack_public_path__ + "img/eu.eu0420e63.svg";